import { NgModule } from "@angular/core";
import { TrainingCandidatesComponent } from "./trainingCandidates";
import { BrowserModule } from "@angular/platform-browser";
import { appRoutingModule } from "../app.routing";
import { FormsModule } from "@angular/forms";
import { ModalModule } from "ngx-bootstrap/modal";
import { PipesModule } from "../pipes";
import { DirectivesModule } from "../directives";
import { TrainingCandidateFormComponent } from "./trainingCandidateForm";
import { DpDatePickerModule } from 'ng2-date-picker';
import { TrainingChangeDetailsFormComponent } from "./trainingChangeDetailsForm";
import { TrainingChangeTrainerCommentComponent } from "./trainingChangeTrainerComment";

@NgModule({
  	declarations: [
		TrainingCandidatesComponent,
		TrainingCandidateFormComponent,
		TrainingChangeDetailsFormComponent,
		TrainingChangeTrainerCommentComponent
	],
  	imports: [
		BrowserModule,
		appRoutingModule,
		FormsModule,
		DirectivesModule,
		ModalModule.forRoot(),
		PipesModule,
		DpDatePickerModule
	],
  	providers: [	
	]
})
export class TrainingCandidatesModule {}
